import { graphql } from "@/lib/gql/__generated__/gql";

export const DayTripPlanDefault_EditPage_Query = graphql(`
	query DayTripPlanDefault_EditPage($hotelID: ID!, $planID: ID!) {
		plan(hotelID: $hotelID, planID: $planID) {
			id
			hotelID
			planID
			inSale
			isPrivate
			isRequest
			isDayTrip
			# isReservedAtLeastOnce
			name
			mainTarget
			availableRoomIDs
			availableOptionIDs
			requiredOptionIDs
			requiredOptionGroupIDs
			defaultDiscountID
			availableDiscountIDs
			checkInStart
			checkInEnd
			checkOut
			isUncancelable
			isUnchangeable
			isChangeOnlyOption
			roomChangeDisable
			maxRoomNum
			minRoomNum
			minimumPeopleNumPerRoom
			maxPeopleNumPerRoom
			notSendCinMail
			isNoAddressNeeded
			isShowRoomForGuest
			includedMeals
			isHiddenHotelQuestions
			onlyUseLocalPayment
			onlyUseCreditPayment
			saleTypeForTerm
			saleStart
			saleEnd
			saleStartTime
			saleEndTime
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
			isHolidayStayable
			checkInAvailableDayOfTheWeek
			isHolidayCheckInAvailable
			requiredPrepMillisecond
			saleStartBeforeDate
			maxStockNum
			soldNumTotal
			maxDailyStockNum
			stockTypeTerm
			stockTypeTarget
			doNotCountKidsAsStock
			billingTypeTerm
			billingTypeTarget
			isRoomPriceFree
			isSCConnected
			isCoSleepingKidsPriceActive
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			keyVisuals {
				bucket
				key
				region
				mimeType
				fileName
			}
			kidsPolicy {
				kidsMaxAge
				kidsDiscountType
				ratio
				static {
					currencyType
					amount
				}
			}
			cancelPolicy {
				beforeDays
				chargeRatio
			}
			longStayParams {
				minimumStayDates
			}
			shortStayParams {
				maximumStayDates
			}
			emailTemplateReservation {
				atCreated
				atUpdated
				atCanceled
				atCin
			}
			questions {
				questionID
				required
				questionType
				question
				options
			}
			price {
				currencyType
				amount
			}
			staticPriceParams {
				staticRoomPrices {
					roomID
					roomName
					prices {
						adultNum
						price {
							currencyType
							amount
						}
					}
				}
			}
			coSleepingKidsPrice {
				currencyType
				amount
			}
		}
		hotelPolicy(hotelID: $hotelID) {
			id
			questions {
				questionID
				required
				questionType
				question
				options
			}
			requiredPrepMillisecond
		}
		customEmailSetting(hotelID: $hotelID) {
			id
			reservation {
				atCreated
				atUpdated
				atCanceled
				atCin
			}
		}
		hotel(hotelID: $hotelID) {
			email
		}
		roomList(hotelID: $hotelID) {
			id
			rooms {
				id
				hotelID
				roomID
				name
			}
			dummy {
				id
				roomID
				name
			}
		}
		optionList(hotelID: $hotelID) {
			id
			options {
				id
				inSale
				name
				optionID
			}
		}
		discountList(hotelID: $hotelID) {
			id
			ordinary {
				discountID
				id
				inSale
				name
			}
			longTerm {
				name
				id
				discountID
				inSale
			}
			multi {
				id
				inSale
				name
				discountID
			}
		}
		siteControllerSetting(hotelID: $hotelID) {
			id
			siteControllerType
			setUpRoomPriceByChillnn
		}
		planCustomMailSetting(hotelID: $hotelID, planID: $planID) {
			id
			planID
			forReservation {
				atCreated {
					text
					override
				}
				atUpdated {
					text
					override
				}
				atCanceled {
					text
					override
				}
				atCheckInBefore_07days {
					text
					shouldSendEmail
					override
				}
				atCheckInBefore_01days {
					text
					shouldSendEmail
					override
				}
				atCheckInBefore_00days {
					text
					shouldSendEmail
					override
				}
				atCheckOutAfter_01days {
					text
					shouldSendEmail
					override
				}
			}
		}
		basicCustomMailSetting(hotelID: $hotelID) {
			id
			forReservation {
				atCreated {
					text
				}
				atUpdated {
					text
				}
				atCanceled {
					text
				}
				atCheckInBefore_07days {
					text
					shouldSendEmail
				}
				atCheckInBefore_01days {
					text
					shouldSendEmail
				}
				atCheckInBefore_00days {
					text
					shouldSendEmail
				}
				atCheckOutAfter_01days {
					text
					shouldSendEmail
				}
			}
		}
	}
`);
